import Vue from 'vue'
import App from './App.vue'
import Widealui from "wideal-elementui-web2";
import Cookies from 'js-cookie'
import i18n from './lang' // Internationalization
import * as filters from './filters' // global filters
import router from './router'
import store from './store'
import {
    Message
} from 'element-ui';
import "wideal-elementui-web2/lib/theme-chalk/index.css";
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import '@/styles/index.scss' // global css

import './icons' // icon
import './errorLog' // error log
import './permission' // permission control
import './mock' // simulation data
import animated from 'animate.css' //引入animate.css
// import VueAMap from 'vue-amap';


import '@/styles/about/common.css' // 引入关于我们页面公共样式，有版心


Vue.use(animated)


// 公共js
import commonJs from '@/utils/common.js'
Vue.prototype.commonJs = commonJs;


// Vue.use(VueAMap);
// VueAMap.initAMapApiLoader({
// key: '390a02f930d49b80810a463bf2c6063c',
// //插件
// plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
// // 默认高德 sdk 版本为 1.4.4
// v: '1.4.4'
// });

Vue.prototype.$baseurl = window.configPath.baseUrl;
Vue.prototype.$message = Message;

Vue.use(Widealui, {
    size: Cookies.get('size') || 'medium', // set element-ui default size
    i18n: (key, value) => i18n.t(key, value)
})


Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

/* 设置token */
commonJs.setCookie('uwb-login-token', commonJs.getParam('accessToken') || commonJs.getParamHash()['accessToken']);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app');

Vue.use(animated) //使用动画